import React from 'react';
import { motion } from 'framer-motion';
import { Check, MoreHorizontal } from 'lucide-react';
export function ConsultancyUseCase() {
  return <section className="py-24 bg-white overflow-hidden" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-15">
          {/* Left Column: Copy */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-17">
              Built for ERP consultancies.
            </h2>
            <div className="space-y-6" data-id="element-18">
              {['Standardize SOWs and templates across every consultant.', "See every client's systems, projects, and risks in one portfolio.", 'Stay audit‑ready with complete documentation and test histories.'].map((item, i) => <div key={i} className="flex gap-4" data-id="element-19">
                  <div className="shrink-0 h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center mt-0.5" data-id="element-20">
                    <Check className="h-3.5 w-3.5 text-blue-600" data-id="element-21" />
                  </div>
                  <p className="text-lg text-slate-700" data-id="element-22">{item}</p>
                </div>)}
            </div>
          </motion.div>

          {/* Right Column: Portfolio Dashboard Mock */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-23">
            <div className="bg-white rounded-xl border border-slate-200 shadow-xl overflow-hidden" data-id="element-24">
              {/* Fake Window Header */}
              <div className="bg-slate-50 border-b border-slate-200 px-4 py-3 flex items-center justify-between" data-id="element-25">
                <div className="flex gap-2" data-id="element-26">
                  <div className="h-3 w-3 rounded-full bg-slate-300" data-id="element-27"></div>
                  <div className="h-3 w-3 rounded-full bg-slate-300" data-id="element-28"></div>
                  <div className="h-3 w-3 rounded-full bg-slate-300" data-id="element-29"></div>
                </div>
                <div className="text-xs font-medium text-slate-500" data-id="element-30">
                  Client Portfolio
                </div>
                <div className="w-12" data-id="element-31"></div>
              </div>

              {/* Table Header */}
              <div className="grid grid-cols-12 gap-4 px-6 py-3 bg-slate-50/50 border-b border-slate-100 text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-32">
                <div className="col-span-4" data-id="element-33">Client Name</div>
                <div className="col-span-2" data-id="element-34">System</div>
                <div className="col-span-3" data-id="element-35">Status</div>
                <div className="col-span-3 text-right" data-id="element-36">Last Audit</div>
              </div>

              {/* Table Rows */}
              {[{
              name: 'Acme Manufacturing',
              system: 'NetSuite',
              status: 'On Track',
              color: 'bg-green-100 text-green-700',
              date: '2 days ago'
            }, {
              name: 'Global Logistics Inc',
              system: 'SAP S/4',
              status: 'At Risk',
              color: 'bg-red-100 text-red-700',
              date: 'Yesterday'
            }, {
              name: 'TechStart Solutions',
              system: 'Dynamics 365',
              status: 'On Track',
              color: 'bg-green-100 text-green-700',
              date: '4 hours ago'
            }, {
              name: 'Apex Retail Group',
              system: 'Oracle Cloud',
              status: 'Warning',
              color: 'bg-yellow-100 text-yellow-700',
              date: '1 week ago'
            }, {
              name: 'Midwest Health',
              system: 'Workday',
              status: 'On Track',
              color: 'bg-green-100 text-green-700',
              date: 'Just now'
            }].map((row, i) => <div key={i} className="grid grid-cols-12 gap-4 px-6 py-4 border-b border-slate-50 items-center hover:bg-slate-50 transition-colors" data-id="element-37">
                  <div className="col-span-4 font-medium text-slate-900" data-id="element-38">
                    {row.name}
                  </div>
                  <div className="col-span-2 text-sm text-slate-500" data-id="element-39">
                    {row.system}
                  </div>
                  <div className="col-span-3" data-id="element-40">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${row.color}`} data-id="element-41">
                      {row.status}
                    </span>
                  </div>
                  <div className="col-span-3 text-right text-sm text-slate-400 flex items-center justify-end gap-2" data-id="element-42">
                    {row.date}
                    <MoreHorizontal className="h-4 w-4 text-slate-300 hover:text-slate-500 cursor-pointer" data-id="element-43" />
                  </div>
                </div>)}
            </div>

            {/* Decorative Elements */}
            <div className="absolute -z-10 top-10 -right-10 w-full h-full bg-blue-50 rounded-xl transform rotate-3" data-id="element-44"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}